import { InputTextarea } from 'primereact/inputtextarea';
import { UploadFile } from './upload-file/upload-file';
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { addNewFeedbackOperation } from './operations/add-new-feedback-operation';
import { FileUploadFile } from 'primereact/fileupload';

interface AddNewDocFeedbackDatamodel {
  userId: number;
  docId: number;
  onFeedbackSubmit?: (
    userId: number,
    docId: number,
    value: string,
    file?: FileUploadFile,
  ) => any;
  onFinish?: () => any;
  isLoading?: boolean;
  uploadFileBodyText?: string;
}
export const AddNewDocFeedback: React.FC<AddNewDocFeedbackDatamodel> = ({
  userId,
  docId,
  onFeedbackSubmit,
  onFinish,
  isLoading,
  uploadFileBodyText,
}) => {
  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isLoading !== undefined) {
      setLoading(isLoading);
    }
  }, [isLoading]);

  const handleAddFeedback = async () => {
    if (onFeedbackSubmit) {
      await onFeedbackSubmit(userId, docId, value, uploadedFile);
    } else {
      await addNewFeedbackOperation(
        userId,
        docId,
        value,
        setLoading,
        uploadedFile,
        onFinish,
      );
    }
  };

  return (
    <div style={{ marginRight: '8px', marginTop: '16px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <InputTextarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          rows={5}
          cols={30}
          style={{ marginBottom: '8px', height: '75px' }}
        />
        <UploadFile
          onFileUploaded={setUploadedFile}
          uploadFileBodyText={uploadFileBodyText}
        />
      </div>
      <div style={{ marginTop: '8px' }}>
        <Button
          style={{ height: '30px', fontSize: '14px' }}
          severity={'secondary'}
          outlined={true}
          label={'איפוס'}
          loading={loading}
          onClick={() => setValue('')}
        />

        <Button
          style={{ height: '30px', fontSize: '14px', marginRight: '8px' }}
          outlined={false}
          disabled={value.length < 3}
          label={'אישור'}
          loading={loading}
          onClick={handleAddFeedback}
        />
      </div>
    </div>
  );
};
